const transformButtons = () => {
    const allButtons = Array.from(document.querySelectorAll('.fh-button'));

    if (allButtons.length > 0) {
        allButtons.forEach(button => {
            button.textContent = "";
            button.classList.add('btn', 'solid');
            button.insertAdjacentHTML("afterbegin", "<span class='btn-text'>Book Now</span><div class='btn-wave'></div>");
            button.classList.remove('fh-button');
            console.log(button);
        })
    }
}

export default transformButtons;